module.exports = __webpack_public_path__ + "img/推送.cf662260.svg";